import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreProductionComponent } from './pre-production.component';
import { AppMaterialModule } from '../app-material/app-material.module';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';



@NgModule({
  declarations: [PreProductionComponent],
  imports: [
    CommonModule,
    AppMaterialModule,
    FormsModule,
    NgxSpinnerModule
  ],
  exports: [PreProductionComponent]
})
export class PreProductionModule {
    
}
